import { render, staticRenderFns } from "./PrivacyPracticesForm.vue?vue&type=template&id=0c97ee0f&scoped=true&"
import script from "./PrivacyPracticesForm.vue?vue&type=script&lang=js&"
export * from "./PrivacyPracticesForm.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPracticesForm.vue?vue&type=style&index=0&id=0c97ee0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c97ee0f",
  null
  
)

export default component.exports